import AppStoreModule from '@app/store/modules/AppStoreModule';
import { getModule as getStoreModule } from 'vuex-module-decorators';

const appStore: AppStoreModule = getStoreModule(AppStoreModule);

export enum CacheErrorType {
	CachingUnsupportedInClientError = 'CachingUnsupportedInClientError'
}

export default class CacheError extends Error {
	public readonly type: CacheErrorType;

	public constructor(type: CacheErrorType, message?: string) {
		super(message);
		this.name = type;
		this.type = type;
	}
}

export function throwIfNotCachingUnsupportedInClient(error: Error | unknown): void {
	// ignore caching unsupported errors, throw everything else
	if (error instanceof CacheError && error.type === CacheErrorType.CachingUnsupportedInClientError) return;

	throw error;
}

export function throwCacheErrorIfUnsupportedInClient(): void {
	if (!appStore.supportsCaching) {
		throw new CacheError(CacheErrorType.CachingUnsupportedInClientError, 'Caching is unsupported in client');
	}
}
